exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cameraPicture[data-v-19f9efaa]{left:520px;top:200px}.cameraBox[data-v-19f9efaa]{height:calc(100% - 50px)}.cameraBox .toolBox[data-v-19f9efaa]{color:hsla(0,0%,100%,.6);font-family:Microsoft YaHei UI;font-weight:regular;font-size:20px;line-height:normal;letter-spacing:0;text-align:left}.cameraBox .toolBox .direction[data-v-19f9efaa]{border-radius:50%;border:1.93px solid hsla(0,0%,85.1%,.2980392157)}", ""]);

// exports
